import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

interface EmptyStateProps {
  searchQuery: string;
  onClearFilters: () => void;
}

const EmptyState = ({ searchQuery, onClearFilters }: EmptyStateProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <div className="w-24 h-24 rounded-full bg-accent/10 flex items-center justify-center mb-6">
        <Icon name="Search" size={48} color="var(--color-accent)" />
      </div>
      <h3 className="text-2xl font-bold text-primary mb-3">
        {t('portfolio.emptyState.title')}
      </h3>
      <p className="text-secondary text-center max-w-md mb-6">
        {searchQuery
          ? t('portfolio.emptyState.description')
          : t('portfolio.emptyState.description')}
      </p>
      <Button
        variant="outline"
        size="default"
        iconName="RotateCcw"
        iconPosition="left"
        iconSize={18}
        onClick={onClearFilters}
      >
        {t('portfolio.emptyState.clearFilters')}
      </Button>
    </div>
  );
};

export default EmptyState;